<template>
  <div
    style="height: 750px;"
    :style="{ 'background-color': details.backgroundColor }"
  >
    <v-row
      justify="center"
      align-content="center"
      class="mx-1 fill-height"
      :class="[$vuetify.breakpoint.mdAndUp?'pdx-10':'mx-5']"
    >
      <iframe
        width="100%"
        :height="iframeHeight"
        :src="details.video_url"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        data-aos="fade-up"
      ></iframe>
    </v-row>
  </div>
</template>

<script>
import { RESELLER_EVENT_BUS } from "@/views/reseller/js/ResellerEventBus";

  export default {
    name: 'ResellerVideo',
    data: () => ({
      details: {},
      videoLink: "https://www.youtube.com/embed/x44Vc8BtENk"
    }),

    computed: {
      iframeHeight() {
        let size = '0';

        if (this.$vuetify.breakpoint.xs)
          size = '215';
        else if (this.$vuetify.breakpoint.sm)
          size = '480';
        else
          size = '605';
        
        return size;
      },
      resellerDetails: function() {
        return RESELLER_EVENT_BUS.resellerDetails
          ? RESELLER_EVENT_BUS.resellerDetails.section
          : null;
      }
    },

    watch: {
      resellerDetails: {
        handler: function(value) {
          if (value) {
            this.details = value.video;
          }
        },
        immediate: true
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>